import React from 'react';
import { StyledButton } from './Styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FiltersProps } from './types';
import { ICONS } from './constants';
import { FiltersCard, FiltersContainer, FiltersRow, FilterItem, FilterLabel } from './Styles';
import { useTheme } from '../../../context/ThemeContext';
import { ThemeProvider } from 'styled-components';
import { getAntdThemeConfig } from '../../../utils/antdTheme';
import { ConfigProvider } from 'antd';
import DateRangePicker from '../../../commonComponents/DateRangePicker';
import StoresDropDown from '../../Analytics/StoresDropDown';

const Filters: React.FC<FiltersProps> = ({
  selectedDateRange,
  onDateRangeChange,
  selectedStore,
  onStoreChange,
  merchantId,
  role,
  onApplyFilters,
  loading,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: isDarkMode ? 'dark' : 'light' } as const;
  const antdTheme = getAntdThemeConfig(isDarkMode);

  return (
    <ConfigProvider theme={antdTheme}>
      <ThemeProvider theme={theme}>
        <FiltersCard>
          <FiltersContainer>
            <FiltersRow>
              <FilterItem>
                <FilterLabel>Date Range</FilterLabel>
                <DateRangePicker
                  selectedDateRange={selectedDateRange}
                  onDateRangeChange={onDateRangeChange}
                />
              </FilterItem>
              <FilterItem>
                <FilterLabel>Store</FilterLabel>
                <StoresDropDown
                  onOptionSelect={(store) => onStoreChange(store.id)}
                  merchantId={merchantId}
                  role={role}
                />
              </FilterItem>
              <StyledButton
                type="primary"
                icon={<FontAwesomeIcon icon={ICONS.filter} />}
                onClick={onApplyFilters}
                loading={loading}
              >
                Apply Filters
              </StyledButton>
            </FiltersRow>
          </FiltersContainer>
        </FiltersCard>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default Filters;
